import React, { useState, useEffect } from "react";
import DeleteModal from "../../components/Modals/DeleteModal";
import "./editUser.css";
import logoBlue from "../../components/images/logoblue.png";
import { Link, useHistory, useParams } from "react-router-dom";
import { ArrowBack, Delete, Visibility, Add, Sync } from "@material-ui/icons";
import { getUsers } from "../../services/user.services";
import { editUser } from "../../services/user.services";

export default function EditUser(props) {
  let history = useHistory();

  const { userId } = useParams();

  const [userData, setUserData] = useState(null);
  const [initialStateForm, setInitialStateForm] = useState({
    _id: "",
    userName: "",
    email: "",
    contactNumber: "",
    password: "",
    isAdmin: false
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [particularUserData, setParticularUserData] = useState();

  console.log("userId being sent:", initialStateForm._id);

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    handleFormChange("userId", userId);
  }, [userId]);

  useEffect(() => {
    const fnt = async () => {
      try {
        setLoading(true);
        const response = await getUsers(
          JSON.parse(sessionStorage.getItem("myData"))
        );
        console.log("user list successful =====>>>", response.data);
        setUserData(response.data);
      } catch (error) {
        
        console.log("errorrrrrrr in all user list", error);
      } finally {
        setLoading(false);
      }
    };
    fnt();
  }, []);

  useEffect(() => {
    const result = userData?.find((item) => item._id === userId);
    setParticularUserData(result);
    console.log("08", result);

    if (result) {
      setInitialStateForm({
        _id: result._id,
        userName: result.userName,
        email: result.email,
        contactNumber: result.contactNumber,
        password: "",
        isAdmin: false
      });
    }
  }, [userData]);

  const handleCreate = async (e) => {
    e.preventDefault();
    console.log("called func", initialStateForm);
    try {
      setLoading(true);
      const response = await editUser(
        initialStateForm,
        JSON.parse(sessionStorage.getItem("myData"))
      );
      console.log("editUser request workingggggg", response.data);
      history.goBack();
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="user">
      <div className="userHeader">
        <div className="titleWithBack">
          <button className="backBtn" onClick={() => history.goBack()}>
            <ArrowBack className="backBtnIcon" />
          </button>
          <h1 className="userTitle">Edit User</h1>
        </div>
        <img className="userLogo" src={logoBlue} alt="logo" width="150px"></img>
      </div>

      <div className="userDetailsView">
        <form className="editUserForm">
          <div className="editUserItem">
            <input
              type="text"
              placeholder="User Name"
              value={initialStateForm.userName}
              onChange={(e) => handleFormChange("userName", e.target.value)}
            />
          </div>
          <div className="editUserItem">
            <input
              type="email"
              placeholder="User Email Address"
              value={initialStateForm.email}
              onChange={(e) => handleFormChange("email", e.target.value)}
            />
          </div>
          <div className="editUserItem">
            <input
              type="text"
              placeholder="Contact Number"
              value={initialStateForm.contactNumber}
              onChange={(e) =>
                handleFormChange("contactNumber", e.target.value)
              }
            />
          </div>
          <div className="editUserItem">
            <input
              type="password"
              value={initialStateForm.password}
              placeholder="New Password"
              onChange={(e) => handleFormChange("password", e.target.value)}
            />
          </div>
          <div className="editUserItemEmpty"></div>
          <button className="editUserButton" onClick={handleCreate}>
            {loading ? <Sync /> : <p>SAVE</p>}
          </button>
        </form>
      </div>
    </div>
  );
}
